// 匯出 Job 共用 helper：啟動背景匯出 → 輪詢狀態 → 下載檔案。
// 回傳值的形狀與 axios 的 blob 回應相同（{ data, headers }），呼叫端原本「取檔名、建立 Blob、下載」
// 的程式碼不用改。啟動被拒絕（例如已有匯出進行中）會是一般的 HTTP 錯誤回應，
// Job 執行中失敗則丟出帶有 response.data.error.text 的錯誤，呼叫端可直接取 text 顯示。
import axios from 'axios';

const POLL_INTERVAL_MS = 2000;
// 前端等待上限（保底）；後端有自己的逾時設定。
const MAX_WAIT_MS = 2 * 60 * 60 * 1000;

function jobError(message) {
  const err = new Error(message);
  err.response = { data: { error: { text: message } } };
  return err;
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * @param {object} options
 * @param {string} options.url          匯出網址（會回 { job_id }）
 * @param {object} options.params      查詢參數（含 filter）
 * @param {object} options.headers      授權標頭
 * @param {string} options.statusBase   Job 查詢網址前綴，例如 VUE_APP_APIPATH + 'model/export_jobs'
 */
export async function exportViaJob({ url, params, headers, statusBase }) {
  const startRes = await axios.get(url, { params, headers });
  const jobId = startRes && startRes.data && startRes.data.job_id;
  if (!jobId) {
    // 後端以 200 回傳失敗內容時（例如已有匯出進行中），直接顯示後端訊息
    const body = (startRes && startRes.data) || {};
    const text = body.error && body.error.text;
    throw jobError(text || '匯出啟動失敗，請稍後再試');
  }

  const startedAt = Date.now();
  for (;;) {
    await sleep(POLL_INTERVAL_MS);
    const statusRes = await axios.get(`${statusBase}/${jobId}`, { headers });
    const { status, error } = statusRes.data || {};
    if (status === 'done') break;
    if (status === 'error') throw jobError(error || '匯出失敗，請稍後再試');
    if (Date.now() - startedAt > MAX_WAIT_MS) throw jobError('匯出逾時，請縮小篩選範圍後重試');
  }

  return axios.get(`${statusBase}/${jobId}/download`, { headers, responseType: 'blob' });
}
